import React from 'react';
import styled from '@emotion/styled';
import Image from 'next/image';

const text = {
  title: '또는',
  email: '이메일 ',
  password: '비밀번호 ',
};

export const InputComponent = (props) => {
  const { values, bottomText, handleChange } = props;
  return (
    <InputContainer>
      <Title>{text.title}</Title>
      <MobileInputTitle>
        {text.email}
        <Image src='/red_dot.png' alt='red_dot' width={5} height={5} />
      </MobileInputTitle>
      <InfoWarp>
        <InputTitle>
          {text.email}
          <Image src='/red_dot.png' alt='red_dot' width={5} height={5} />
        </InputTitle>
        <InfoInput
          placeholder='example@legalengine.co.kr'
          name='email'
          type='email'
          autoComplete='off'
          required
          value={values.email}
          onChange={handleChange}
        />
      </InfoWarp>
      <MobileInputTitle>
        {text.password}
        <Image src='/red_dot.png' alt='red_dot' width={5} height={5} />
      </MobileInputTitle>
      <InfoWarp>
        <InputTitle>
          {text.password}
          <Image src='/red_dot.png' alt='red_dot' width={5} height={5} />
        </InputTitle>
        <InfoInput
          placeholder='영어 소문자+숫자, 10자 이상'
          name='password'
          type='password'
          value={values.password}
          autoComplete='new-password'
          onChange={handleChange}
        />
      </InfoWarp>
      <BottomTextWarp>
        {bottomText.password && <BottomWarningText>{bottomText.loginPassword}</BottomWarningText>}
      </BottomTextWarp>
    </InputContainer>
  );
};

const InputContainer = styled.article`
  padding-bottom: 2rem;
  @media only screen and (max-width: 992px) {
    padding: 0;
  }
`;

const Title = styled.header`
  text-align: center;
  font-size: 23px;
  @media only screen and (max-width: 992px) {
    font-size: 20px;
  }
`;

const MobileInputTitle = styled.div`
  display: none;
  @media only screen and (max-width: 992px) {
    display: block;
    margin-top: 30px;
  }
`;

const InputTitle = styled.div`
  text-align: left;
  align-self: center;
  font-size: 18px;
  width: 20%;
  @media only screen and (max-width: 992px) {
    display: none;
  }
`;

const Input = styled.input`
  height: 50px;
  padding: 0 1rem;
  background-color: #ffffff;
  border: 1px solid #c4c4c4;
  box-sizing: border-box;
  ::placeholder {
    color: #c4c4c4;
  }
  :focus {
    border: 1px solid #002366;
  }
`;

const InfoWarp = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 30px;
  @media only screen and (max-width: 992px) {
    margin-top: 20px;
  }
`;

const InfoInput = styled(Input)`
  width: 80%;
  @media only screen and (max-width: 992px) {
    width: 100%;
  }
`;

const BottomTextWarp = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 10px;
`;

const BottomText = styled.span`
  font-size: 16px;
  width: 80%;
  color: #6f6f6f;
  text-align: left;
  @media only screen and (max-width: 992px) {
    width: 100%;
    font-size: 14px;
  }
`;

const BottomWarningText = styled(BottomText)`
  color: #dc3545;
`;
